export default __webpack_public_path__ + "static/media/My_car_website_images-12_17.ff8ea051.jpg";